import { render, staticRenderFns } from "./Appraisal.vue?vue&type=template&id=5caf11b4&scoped=true&"
import script from "./Appraisal.vue?vue&type=script&lang=js&"
export * from "./Appraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf11b4",
  null
  
)

export default component.exports